<select
        #TimeZoneCombobox
        class="form-control"
        [(ngModel)]="selectedTimeZone"
        (ngModelChange)="selectedTimeZoneChange.emit($event)"
    >
        <option *ngFor="let timeZone of timeZones" [value]="timeZone.value">{{ timeZone.name }}</option>
    </select>


// WEBPACK FOOTER //
// ./src/app/shared/common/timing/timezone-combo.component.ts.TimeZoneComboComponent.html